import { Component, OnInit, OnChanges, Input, SimpleChanges } from '@angular/core';
import { LoggerService } from 'src/shared/logger/logger.service';
import { Levels } from 'src/shared/logger/levels.enum';
import { SystemProfileService } from 'src/system-profile-manager/shared/system-profile-V2.service';
import { MatDialog } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { DialogConfirmationComponent } from 'src/shared/Dialogs/dialog-confirmation/dialog.confirmation.component';
import { MatTableDataSource } from '@angular/material/table';
import { folderSystem } from 'src/system-profile-manager/shared/folder.system.model';

@Component({
  selector: 'folder-systems-component',
  templateUrl: './folder-systems.component.html',
  styleUrls: ['./folder-systems.component.css']
})
export class FolderSystemsComponent implements OnInit, OnChanges {
  receivedUnits: folderSystem[] = [];
  displayedColumns = ["icon", "system_name", "system_ip", "parentFolder", "last_monitored_date", "status"];
  logsTableData: MatTableDataSource<folderSystem> = new MatTableDataSource([]);
  @Input() selected_folder: { id: Number, type: string };
  selectedFolderId: Number;

  constructor(private loggerService: LoggerService,
    private systemService: SystemProfileService,
    private _snackBar: MatSnackBar, public dialog: MatDialog,
  ) {
  }
  ngOnChanges(changes: SimpleChanges): void {
    if (this.selectedFolderId != this.selected_folder?.id) {
      this.selectedFolderId = this.selected_folder?.id;
      this.getSystemsInFolder();
    }
  }

  ngOnInit(): void {
    if (this.selectedFolderId != this.selected_folder?.id) {
      this.selectedFolderId = this.selected_folder?.id;
      this.getSystemsInFolder();
    }
  }

  getSystemsInFolder() {
    this.systemService.getFolderSystems(this.selectedFolderId).subscribe(response => {
      this.receivedUnits = response["message"].sort((a, b) => (a.system_name < b.system_name) ? -1 : ((a.system_name < b.system_name) ? 1 : 0))
      this.logsTableData = new MatTableDataSource(this.receivedUnits);
    }, err => {
      this.loggerService.log("FolderSystemsComponent", err.message, Levels.error)
    })
  }

  openSnackBar(message: string, action: string) {
    this._snackBar.open(message, action, {
      duration: 8000,
      panelClass: ['mat-toolbar', 'mat-primary']
    });
  }

  openDialog(): void {
    const dialogRef = this.dialog.open(DialogConfirmationComponent, {
      width: '450px',
      data: { title: "Update system location", message: `Are you sure you want to move ` },
      disableClose: true
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {

      }
    });
  }

  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.logsTableData.filter = filterValue.trim().toLowerCase();
  }

  returnElementColor(element: folderSystem) {
    if (element.status == "No HTTPS response") return "red";
    else if (element.status == "Idle" || element.status == "In a call") return "green";
    else return "blue";
  }

  goToLink(endpoint) {
    let url = "https://" + endpoint.system_ip + "/"
    window.open(url, "_blank");
  }

}
